import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { Close } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

type VenueMatchBannerProps = Readonly<{
  onTagAsOurPick: () => void;
  onWeAreStayingHere: () => void;
  onDismiss: () => void;
  isLoading?: boolean;
}>;

export const VenueMatchBanner = ({ onTagAsOurPick, onWeAreStayingHere, onDismiss, isLoading }: VenueMatchBannerProps) => {
  const { tq } = useTranslation('accommodationsAdmin');

  return (
    <Flex
      flexDirection="column"
      gap={2}
      paddingX={5}
      paddingY={4}
      backgroundColor="mono2"
      position="relative"
      borderRadius={`0 0 ${pxToRem(11)} ${pxToRem(11)}`}
    >
      <ButtonV2
        variant="ghost"
        intent="neutral"
        size="sm"
        position="absolute"
        top={pxToRem(4)}
        right={pxToRem(4)}
        onClick={e => {
          e.stopPropagation();
          onDismiss();
        }}
        aria-label={tq`Dismiss`}
        padding={0}
        minWidth="auto"
        height="auto"
        color="mono8"
        _hover={{ color: 'mono12', backgroundColor: 'transparent' }}
      >
        <Close size={12} />
      </ButtonV2>
      <TextV2
        typographyVariant="label3"
        fontWeight="bold"
        color="mono14"
      >
        {tq`This looks like your wedding venue`}
      </TextV2>
      <TextV2
        typographyVariant="label2"
        color="mono8"
      >
        {tq`Tag it so guests spot it first.`}
      </TextV2>
      <Flex
        gap={5}
        marginTop={1}
      >
        <ButtonV2
          variant="link"
          intent="neutral"
          size="sm"
          padding={0}
          minWidth="auto"
          height="auto"
          fontWeight="bold"
          fontSize={pxToRem(13)}
          color="mono14"
          textDecoration="underline"
          disabled={isLoading}
          onClick={e => {
            e.stopPropagation();
            onTagAsOurPick();
          }}
          _hover={{ color: 'mono12' }}
        >
          {tq`Tag as Our Pick`}
        </ButtonV2>
        <ButtonV2
          variant="link"
          intent="neutral"
          size="sm"
          padding={0}
          minWidth="auto"
          height="auto"
          fontWeight="bold"
          fontSize={pxToRem(13)}
          color="mono14"
          textDecoration="underline"
          disabled={isLoading}
          onClick={e => {
            e.stopPropagation();
            onWeAreStayingHere();
          }}
          _hover={{ color: 'mono12' }}
        >
          {tq`We're staying here`}
        </ButtonV2>
      </Flex>
    </Flex>
  );
};
